import {PayloadAction, createSlice} from '@reduxjs/toolkit'
import {IFetchAmandementParams} from '../../api/modules/master-data/types'
import {RootState} from '../../store'

export interface IState {
  filterAmandement: IFetchAmandementParams
}

const initialState: IState = {
  filterAmandement: {
    per_page: 5,
    is_amendment: false,
    city: '',
    province: '',
    created_at: '',
    customer_name: '',
    po_number: '',
    product_name: '',
    regarding: '',
    sector_id: '',
    status: '',
    total_left_price: '',
    total_left_quantum: '',
  },
}

/**
 * Slices
 */
const amandementSlice = createSlice({
  name: 'amandement',
  initialState,
  reducers: {
    setFilterAmandement: (state: IState, action: PayloadAction<IFetchAmandementParams>) => {
      state.filterAmandement = action.payload
    },
    resetFilterAmandement: (state: IState) => {
      state.filterAmandement = initialState.filterAmandement
    },
  },
})

/**
 * Actions
 */
export const {setFilterAmandement, resetFilterAmandement} = amandementSlice.actions

/**
 * Selector
 */
export const amandementSelector = (state: RootState) => state.amandmentReducer

/**
 * Reducer
 */
export default amandementSlice.reducer
